import type { IntlShape } from "react-intl";
import { array, boolean, literal, number, object, string } from "zod";

export const createValidationSchema = (intl: IntlShape) =>
  object({
    tripDate: string().date(),
    travellers: object({
      adultInSingleRoom: number().min(0),
      adultInDoubleRoom: number()
        .min(0)
        .refine((val) => val % 2 === 0, {
          message: intl.formatMessage({
            id: "trips.validation.adultInDoubleRoomMustBeEvenNumber",
          }),
        }),
      childWithBed: number().min(0),
      childWithoutBed: number().min(0),
      infant: number().min(0),
    }).refine(
      (travellers) =>
        travellers.adultInSingleRoom + travellers.adultInDoubleRoom >= 1,
      {
        message: intl.formatMessage({ id: "trips.validation.atLeastOneAdult" }),
        path: ["travellers"],
      },
    ),
    selectedTravellers: object({
      ADT: array(string().nullable())
        .min(1, intl.formatMessage({ id: "trips.validation.atLeastOneAdult" }))
        .readonly(),
      CHD: array(string().nullable()).readonly(),
      INF: array(string().nullable()).readonly(),
    }),
    termsAndConditions: literal<boolean>(true),
    isTripTourAdded: boolean(),
    promoCode: string().optional(),
  });
